import React from 'react'
import { LabelWithIcon } from 'molecules/LabelEnhanced'
import {
  COLLABORATION_ADD_CC,
  COLLABORATION_REMARK,
  COLLABORATION_IMAGE,
  COLLABORATION_DOCUMENT,
  COLLABORATION_DEPARTMENT
} from 'fixtures/collabTypes'
import { Popup } from './styles'

const icons = {
  ic_share_bk: require('App/assets/images/ic_share_bk.png'),
  ic_pic_bk: require('App/assets/images/ic_pic_bk.png'),
  ic_doc_bk: require('App/assets/images/ic_doc_bk.png'),
  ic_plus_bk: require('App/assets/images/ic_plus_bk.png'),
  ic_user_bk: require('App/assets/images/ic_user_bk.png'),
}

const Menu = ({ isShow, fn, current }) => {
  const openFile = (name) => {
    document.getElementById(`pick${name}`).click()
    fn(name)
  }

  return (
    <Popup show={isShow}>
      <LabelWithIcon showPointer={true} icon={icons.ic_user_bk} onClick={() => fn(COLLABORATION_ADD_CC)} text={'Add Cc'} />
      <LabelWithIcon showPointer={true} icon={icons.ic_pic_bk} onClick={() => openFile(COLLABORATION_IMAGE)} text={'Add Image'} />
      <LabelWithIcon showPointer={true} icon={icons.ic_share_bk} onClick={() => fn(COLLABORATION_DEPARTMENT)} text={'Add Collaborator Departement'} />
      <LabelWithIcon showPointer={true} icon={icons.ic_doc_bk} onClick={() => openFile(COLLABORATION_DOCUMENT)} text={'Add Document'} />
      <LabelWithIcon showPointer={true} icon={icons.ic_plus_bk} onClick={() => fn(COLLABORATION_REMARK)} text={'Add Remarks'} />
    </Popup>
  )
}

export default Menu
